/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import {Link, useLocation, useHistory} from 'react-router-dom'
import {
  SEARCH_PRODUCT,
  SEARCH_PRODUCTTAG,
  SEARCH_PRODUCT_HIERARCHY,
} from '../../../../app/store/queries'
import {
  SearchListModel,
  ProductEdge,
  ProductHierarcyEdge,
  ProductTagEdge,
  ProductNode,
  ProductTagNode,
  ProductTag,
} from '../../../../app/types'
import {MenuComponent} from '../../../assets/ts/components'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {DefaultTitle} from './page-title/DefaultTitle'
import {Topbar} from './Topbar'
import {useApolloClient} from '@apollo/client'
import {left} from '@popperjs/core'
import {Search} from '../../../partials'
import {isMobile} from 'react-device-detect'
import {Toolbar} from '../toolbar/Toolbar'

export function HeaderWrapper() {
  const {pathname} = useLocation()
  const history = useHistory()
  const location = useLocation()
  const {config, classes, attributes} = useLayout()
  const client = useApolloClient()
  const {header, aside} = config
  const [productSearchResult, setProductSearchResult] = useState<ProductEdge | undefined>()
  const [productTagSearchResult, setProductTagSearchResult] = useState<ProductTagEdge | undefined>()
  const [productHierarchySearchResult, setProductHierarchySearchResult] = useState<
    ProductHierarcyEdge | undefined
  >()

  const [searchText, setSearchText] = useState<string>('')

  useEffect(() => {
    setProductHierarchySearchResult(undefined)
    setProductSearchResult(undefined)
  }, [location])

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [pathname])

  useEffect(() => {
    console.log('31 =>>', productSearchResult)

    console.log('33 =>>', productSearchResult?.edges)
  }, [productSearchResult])

  useEffect(() => {
    console.log('searchText =>>', searchText)

    if (searchText.length > 2) {
      startSearch()
    } else {
      setProductHierarchySearchResult(undefined)
      setProductSearchResult(undefined)
      setProductTagSearchResult(undefined)
    }
  }, [searchText])

  const startSearch = () => {
    if (searchText != undefined && searchText != '' && searchText.length > 1) {
      const secondValue = searchText
        .replace('o', 'ö')
        .replace('c', 'ç')
        .replace('u', 'ü')
        .replace('g', 'ğ')
        .replace('s', 'ş')
      searchProducts(searchText, secondValue)
      searchProductHierarchies(searchText, secondValue)
      searchProductTags(searchText, secondValue)
    }
  }

  async function searchProductTags(searchText: string, searchText2: string) {
    return await client
      .query({
        query: SEARCH_PRODUCTTAG,
        variables: {searchString: searchText, searchString2: searchText2},
      })
      .then((resp: any) => {
        console.log('product tag model  => ', resp)
        if (resp.error) {
          return false
        } else {
          try {
            searchText && searchText != '' && setProductTagSearchResult(resp.data.productTagList)
          } catch (err) {
            console.log('burada => ', err)
          }
        }
      })
      .catch((err: any) => {
        console.log('error activity list => ', err)
        return false
      })
  }

  async function searchProducts(searchText: string, searchText2: string) {
    return await client
      .query({
        query: SEARCH_PRODUCT,
        variables: {searchString: searchText, searchString2: searchText2},
      })
      .then((resp: any) => {
        console.log('product model  => ', resp)
        if (resp.error) {
          return false
        } else {
          try {
            searchText && searchText != '' && setProductSearchResult(resp.data.products)
          } catch (err) {
            console.log('burada => ', err)
          }
        }
      })
      .catch((err: any) => {
        console.log('error activity list => ', err)
        return false
      })
  }

  async function searchProductHierarchies(searchText: string, searchText2: string) {
    return await client
      .query({
        query: SEARCH_PRODUCT_HIERARCHY,
        variables: {searchString: searchText, searchString2: searchText2},
      })
      .then((resp: any) => {
        console.log('SEARCH_PRODUCT_HIERARCHY model  => ', resp)
        if (resp.error) {
          return false
        } else {
          try {
            searchText &&
              searchText != '' &&
              setProductHierarchySearchResult(resp.data.productHierarchies)
          } catch (err) {
            console.log('burada => ', err)
          }
        }
      })
      .catch((err: any) => {
        console.log('error activity list => ', err)
        return false
      })
  }
  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      <Link to={'/dashboard'}>
        <i className='bi bi-box-arrow-in-left'></i>
      </Link>
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div
            style={{width: '15%'}}
            className='d-flex align-items-center d-lg-none ms-n3 me-1'
            title='Show aside menu'
          >
            <div
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <KTSVG path='/media/icons/duotone/Text/Menu.svg' className='svg-icon-2x mt-1' />
            </div>
          </div>
        )}
        {/* end::Aside mobile toggle */}

        <div
          style={{
            width: '70%',
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'nowrap',
            justifyContent: 'center',
          }}
        >
          <div className='input-group input-group-lg' style={{position: 'relative'}}>
            {/* {searchText && searchText != "" && <span style={{ position: "absolute", right: "7%", zIndex: 1, top: "27%" }}>
              <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                onClick={() => {
                  setSearchText("")
                }}
                style={{ width: 25 }}
                width={25}>
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
              </svg>
            </span>} */}
            <input
              type='text'
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              className='form-control'
              aria-label='Sizing example input'
              aria-describedby='inputGroup-sizing-lg'
            />
            <span
              className='input-group-text searchButton'
              id='inputGroup-sizing-lg'
              onClick={() => startSearch()}
            >
              Ara
            </span>

            {searchText &&
              searchText != '' &&
              ((productHierarchySearchResult != null &&
                productHierarchySearchResult.edges.length > 0) ||
                (productSearchResult != null && productSearchResult.edges.length > 0) ||
                (productTagSearchResult != null && productTagSearchResult.edges.length > 0)) && (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  onClick={() => setSearchText('')}
                  style={{
                    position: 'absolute',
                    right: isMobile ? '21%' : '6%',
                    top: '8%',
                    width: '50px',
                    height: '36px',
                    zIndex: 99,
                  }}
                  width='16'
                  height='16'
                  fill='currentColor'
                  className='bi bi-x'
                  viewBox='0 0 16 16'
                >
                  <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                </svg>
              )}
          </div>
          <div
            style={{
              position: 'relative',
              display:
                productSearchResult != undefined || productHierarchySearchResult != undefined
                  ? 'block'
                  : 'none',
            }}
          >
            <div
              className='customScroll'
              style={{
                position: 'absolute',
                boxShadow: '0px 4px 4px 1px',
                background: 'white',
                border: '1px solid  #E4E6EF',
                padding: '4px',
                width: '100%',
                height: 400,
                overflow: 'scroll',
              }}
            >
              <div>
                <div className='search-landings' style={{flexWrap: isMobile ? 'unset' : 'wrap'}}>
                  {productTagSearchResult?.edges
                    .sort((a: ProductTagNode, b: ProductTagNode) =>
                      a.node.tagText > b.node.tagText ? 1 : -1
                    )
                    .map((x) => (
                      <div className='landings'>
                        <a
                          title={x.node.tagText}
                          href={'productTag?ProductTag=' + x.node.tagText}
                          target='_blank'
                        >
                          {x.node.tagText}
                        </a>
                      </div>
                    ))}
                </div>
              </div>
              {productHierarchySearchResult != undefined &&
                productHierarchySearchResult.edges?.map((x) => (
                  <div
                    style={{height: isMobile ? 100 : 72.5}}
                    className='searchItemsClass'
                    key={x.node.guid}
                    onClick={() => history.push('/subHierarchyList?guid=' + x.node.guid)}
                  >
                    <div style={{width: 50, marginLeft: '1%', marginRight: '1%'}}>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='50'
                        height='50'
                        style={{color: '#5da2ff'}}
                        fill='currentColor'
                        className='bi bi-grid-fill'
                        viewBox='0 0 16 16'
                      >
                        <path d='M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z' />
                      </svg>
                    </div>
                    <div style={{fontWeight: 'bold', fontSize: 14, width: '100%'}}>
                      {x?.node.displayName}
                      {!isMobile && (
                        <span style={{float: 'right', color: '#80808087', marginRight: '1%'}}>
                          {x?.node?.parentHierarchy != null
                            ? x?.node?.parentHierarchy?.displayName
                            : ''}
                        </span>
                      )}
                      <div>
                        {isMobile && (
                          <span style={{color: '#80808087', marginRight: '1%', marginLeft: '1%'}}>
                            {x?.node?.parentHierarchy != null
                              ? x?.node?.parentHierarchy?.displayName
                              : ''}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

              {productSearchResult != undefined &&
                productSearchResult?.edges?.map((x) => (
                  <div
                    style={{height: isMobile ? 120 : 72.5}}
                    className='searchItemsClass'
                    key={x.node.guid}
                    onClick={() => {
                      history.push('/productDetail?guid=' + x.node.guid)
                      if (window.location.href.includes('productDetail')) {
                        window.location.reload()
                      }
                    }}
                  >
                    <div style={{width: 50, marginLeft: '1%', marginRight: '1%'}}>
                      {x.node?.detailedDescription?.includes(searchText) ||
                      x.node?.shortDescription?.includes(searchText) ? (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='50'
                          height='50'
                          style={{color: 'rgb(117 223 66)'}}
                          fill='currentColor'
                          className='bi bi-info-square-fill'
                          viewBox='0 0 16 16'
                        >
                          <path d='M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' />
                        </svg>
                      ) : (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='50'
                          height='50'
                          style={{color: '#4f42df'}}
                          fill='currentColor'
                          className='bi bi-p-square-fill'
                          viewBox='0 0 16 16'
                        >
                          <path d='M8.27 8.074c.893 0 1.419-.545 1.419-1.488s-.526-1.482-1.42-1.482H6.778v2.97H8.27Z' />
                          <path d='M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.5 4.002h2.962C10.045 4.002 11 5.104 11 6.586c0 1.494-.967 2.578-2.55 2.578H6.784V12H5.5V4.002Z' />
                        </svg>
                      )}
                    </div>
                    <div style={{width: '100%'}}>
                      <div
                        style={{
                          fontWeight: 'bold',
                          fontSize: 14,
                          marginTop:
                            x?.node?.productTags != null && x.node.productTags.length > 0
                              ? '1%'
                              : 0,
                        }}
                      >
                        <span>{x?.node.displayName}</span>
                        {!isMobile && (
                          <span style={{float: 'right', color: '#80808087', marginRight: '1%'}}>
                            {x?.node.productHierarchy != null
                              ? x?.node?.productHierarchy?.displayName
                              : ''}
                          </span>
                        )}
                      </div>
                      <div>
                        {isMobile && (
                          <span style={{color: '#80808087', marginRight: '1%', marginLeft: '1%'}}>
                            {x?.node.productHierarchy != null
                              ? x?.node?.productHierarchy?.displayName
                              : ''}
                          </span>
                        )}
                      </div>

                      <div
                        style={{
                          maxWidth: isMobile ? 141 : 600,
                          overflow: 'scroll',
                          overflowY: 'hidden',
                        }}
                      >
                        <div
                          className='search-landings'
                          style={{flexWrap: isMobile ? 'unset' : 'wrap'}}
                        >
                          {x?.node?.productTags
                            ?.sort((a: ProductTag, b: ProductTag) =>
                              a.tagText > b.tagText ? 1 : -1
                            )
                            .map((tag) => (
                              <>
                                {tag.tagText != 'Gemi' &&
                                  tag.tagText != 'Numune' &&
                                  tag.tagText != 'Balık' &&
                                  tag.tagText != 'SalesPedia' && (
                                    <div className='landings'>
                                      <span title={tag.tagText}>{tag.tagText}</span>
                                    </div>
                                  )}
                              </>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {/* begin::Wrapper */}
        <div
          style={{width: '15%'}}
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {/* begin::Navbar */}
          {header.left === 'menu' && (
            <div className='d-flex align-items-stretch' id='kt_header_nav'>
              <Header />
            </div>
          )}

          {header.left === 'page-title' && (
            <div className='d-flex align-items-center' id='kt_header_nav'>
              <DefaultTitle />
            </div>
          )}

          <div className='d-flex align-items-stretch flex-shrink-0'>
            <Topbar />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}
